module.exports = __webpack_public_path__ + "assets/profile-white.6640c025.svg";